export default {
  // 格式化时间戳
  formatDate (timestamp, type = 'ymd') {
    if ((timestamp + '').indexOf('+0000') >= 0) {
      timestamp = timestamp.replace('+0000', '')
    }
    let date = new Date(timestamp)
    let y = date.getFullYear()
    let m = date.getMonth() + 1
    m = m < 10 ? ('0' + m) : m
    let d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    let h = date.getHours()
    h = h < 10 ? ('0' + h) : h
    let i = date.getMinutes()
    i = i < 10 ? ('0' + i) : i
    let s = date.getSeconds()
    s = s < 10 ? ('0' + s) : s
    switch (type) {
      case 'ymd': {
        return `${y}-${m}-${d}`
      }
      case 'ymdhi': {
        return `${y}-${m}-${d} ${h}:${i}`
      }
      default: {
        return `${y}-${m}-${d} ${h}:${i}:${s}`
      }
    }
  },

  // 生成随机字符串
  getRandomString (len) {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'

    let result = ''

    for (var i = len; i > 0; --i) {
      result += chars[Math.floor(Math.random() * chars.length)]
    }

    return result
  },

  TransformToChinese (num) {
    var a = numToChn(num);
    num = Math.floor(num);
    var unitPos = 0;
    var strIns = '', chnStr = '';
    var needZero = false;

    if (num === 0) {
      return chnNumChar[0];
    }
    while (num > 0) {
      var section = num % 10000;
      if (needZero) {
        chnStr = chnNumChar[0] + chnStr;
      }
      strIns = sectionToChinese(section);
      strIns += (section !== 0) ? chnUnitSection[unitPos] : chnUnitSection[0];
      chnStr = strIns + chnStr;
      needZero = (section < 1000) && (section > 0);
      num = Math.floor(num / 10000);
      unitPos++;
    }

    return chnStr + a;
  },

  convertSubject (list) {
    const subjectList = []
    list.forEach(item => {
      item.isWai = false
      if (this.getIsWai(item.subjectId)) {
        item.isWai = true
        const curSubject = subjectList && subjectList.find(subject => subject.subjectId == 0)
        if (curSubject) {
          curSubject.children.push(item)
        } else {
          subjectList.push({
            dicCode: 0,
            dicName: '外语',
            subjectId: 0,
            isWai: true,
            children: [item]
          })
        }
      } else {
        subjectList.push(item)
      }
    })
    return subjectList
  },

  getIsWai (subjectId) {
    return foreignLanguage.indexOf(subjectId + '') > -1
  },

  //计算拼接题号
  getNumsNoList (list) {
    for (let item of list) {
      item.nums = standardQuestionNumber(item);
    }
  },
  //计算拼接题号
  getNums (list) {
    for (let item of list) {
      let res = "";
      for (let num of item.list) {
        if (num.examId !== this.examId) {
          let no = standardQuestionNumber(num);
          res += '<span style="color: #447ed9">' + no + "</span>";
        } else {
          res += standardQuestionNumber(num) + "、";
        }
      }
      res = res.substring(0, res.lastIndexOf("、"));
      item.nums = res;
    }
  },
  //添加题号排序字段
  addQNums (val) {
    for (let i of val) {
      if (i.bigNum && i.smallNum) {
        i.qNum = this._zhToDigit(i.bigNum) + i.smallNum;
      } else {
        if (~i.question.indexOf("-")) {
          i.qNum = i.question.split("-")[0];
        } else {
          i.qNum = i.question;
        }
      }
    }
  },
  //题号中文转数字
  _zhToDigit (str) {
    let result = 0;
    let arr = str.split("");
    for (let item of arr) {
      for (let i = 0; i < chnNumChar.length; i++) {
        let z = chnNumChar[i];
        if (item == z) {
          result += i;
        }
      }
    }
    return result;
  },
  standardQuestionNumber,
  // 根据枚举Key获取指定枚举code
  getEnumCodeByKey (exam, key) {
    const object = exam[key]
    if (object) {
      return object.code
    }
    return -1
  },
  // 根据枚举code获取指定枚举值
  getKeyByValue (examEnum, value, kind) {
    return Object.keys(examEnum).find(key => {
      const emun = examEnum[key]
      if (emun) {
        return emun.code === value && emun.kind === kind
      }
    });
  },
  // 检测是否空值
  isEmpty (val) {
    if (typeof val === 'undefined' || val === null || val === '') {
      return true
    }
    return false
  },
}

var chnNumChar = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
var chnUnitSection = ["", "万", "亿", "万亿", "亿亿"];
var chnUnitChar = ["", "十", "百", "千"];
// 外语集合[3:英语，21：日语，22：俄语]
var foreignLanguage = ['3', '21', '22'];

var numToChn = function (num) {
  var index = num.toString().indexOf(".");
  if (index != -1) {
    var str = num.toString().slice(index);
    var a = "点";
    for (var i = 1; i < str.length; i++) {
      a += chnNumChar[parseInt(str[i])];
    }
    return a;
  } else {
    return '';
  }
}

//定义在每个小节的内部进行转化的方法，其他部分则与小节内部转化方法相同
function sectionToChinese (section) {
  var str = '', chnstr = '', zero = false, count = 0;   //zero为是否进行补零， 第一次进行取余由于为个位数，默认不补零
  while (section > 0) {
    var v = section % 10;  //对数字取余10，得到的数即为个位数
    if (v == 0) {                    //如果数字为零，则对字符串进行补零
      if (zero) {
        zero = false;        //如果遇到连续多次取余都是0，那么只需补一个零即可
        chnstr = chnNumChar[v] + chnstr;
      }
    } else {
      zero = true;           //第一次取余之后，如果再次取余为零，则需要补零
      str = chnNumChar[v];
      str += chnUnitChar[count];
      chnstr = str + chnstr;
    }
    count++;
    section = Math.floor(section / 10);
  }
  return chnstr;
}

function standardQuestionNumber (question) {
  return question.bigNum && question.smallNum ? question.bigNum + "." + question.smallNum : question.question ? question.question : question.num ? question.num : '--'
}



// WEBPACK FOOTER //
// ./src/utils/util.js